import React, {useState} from 'react'
import {  FiHome, FiDollarSign, FiChevronDown, FiGlobe, FiSearch, FiChevronRight, FiMenu, FiX, FiChevronLeft } from 'react-icons/fi'

const NavbarMenu = ({tab=false}) =>{
    const [open,setOpen] = React.useState(false);
    
    return (
        <React.Fragment>
            <header id="navbar">
                <div className="header">
                    <div className="logo" >
                        NOVA
                    </div>
                    <div className="flex">
                    <ul className='menus'>  
                        <li> <div className='home' ><FiHome /> <p>Hyper Pro</p> </div> </li>
                        {mainMenuList.map((item,i)=>(
                            <li key={`menu-${i}`}> <a href={item.path}>{item.name}</a> </li>
                        ))}
                        
                    </ul>
                    <ul className='buttons'>
                       {true ? (
                            <li className="myprofile flex"> 
                            <img src="/assets/images/faces/1.png" alt="" />
                             
                                <div className='dropdown'>
                                    <ul>
                                        <li><a href="/profile" className='active'>Profile</a></li>
                                        <li><a href="/account">Dashboard</a></li>
                                        <li><a href="##">Manage Request</a></li>
                                        <li><a href="/projects/create">Post a Request</a></li>
                                        <li><a href="##" className='active'>Refer & Get up to $100</a></li>
                                        <li className='seperator'></li>
                                        <li><a href="/settings">Settings</a></li>
                                        <li><a href="##">English <FiGlobe /></a></li>
                                        <li><a href="##"><FiDollarSign /> Dollar</a></li>
                                        <li><a href="/contact">Help & Support</a></li>
                                        <li className='seperator'></li>
                                        <li><a href="##">Logout</a></li>
                                    </ul>  
                             </div>
                            
                            </li>
                       ):(
                        <li className="sign flex" onClick={()=>{


                        }}> 
                            <p>SIGN IN</p>
                            <div className='button'>JOIN</div>
                        </li>
                       )}
                        <li className='menubar'>
                            <div onClick={()=>setOpen(true)} > <FiMenu size={23} /> </div>
                            {open && (
                                <div className="menubar-dropdown">
                                <div className="heading flex">
                                    <div className='logo'>NOVA</div>
                                    <div onClick={()=>setOpen(false)} ><FiX size={33} /></div>
                                </div>
                                <ul className='flex'>
                                    {mainMenuList.map((item,i)=>(
                                        <li key={`menu-${i}`}> <a href={item.path}>{item.name}</a> </li>
                                    ))}
                                </ul>
                            </div>
                            )}
                        </li>
                    </ul>
                    </div>
                </div>
               <SliderMenu /> 
               {tab && <TabMenu />}
            </header>   
       
        </React.Fragment>
    )
}

export default NavbarMenu;

const mainMenuList = [
    {name:'Explore', path:'#'},
    {name:'Messages', path:'#'},
    {name:'Lists', path:'#'},
    {name:'Orders', path:'#'},
    {name:'Orders', path:'#'},
]

export const SliderMenu = () => {
const scrollRef = React.useRef(null);
const [offsetX,setOffsetX] = React.useState(100);
const scrollRight = () => {
    scrollRef.current.scrollTo(offsetX, 0);
    setOffsetX((prev)=>prev+250);
}
const scrollLeft = () => {
    if(offsetX > 100){
        setOffsetX((prev)=>prev-100);
        scrollRef.current.scrollTo(offsetX, 0);
    } 
}


    return (
        <div className="slider flex">
            {offsetX>100 &&(
                 <div className='slide-left-button' onClick={scrollLeft}>
                     <FiChevronLeft size={25} />
                 </div>
            )}
            <ul ref={scrollRef}>
                <li className='dropdown'>
                    <a href="##"> <p> Graphic & Design  <FiChevronDown /></p> </a>  
                    <div className="megamenu">
                        <ul className="group">
                        {groupMenu.map((item,i)=>(
                            <ul className='list' key={`group-${i}`} >
                                <li className='first'><a href="##">{item.title}</a></li>
                                {item?.children?.length>0 && item.children.map((child,key)=>(
                                    <li key={`list-${key}`}><a href="##">{child.title}</a> {child.new && <div className="badge">NEW</div> } </li>
                                ))}
                            </ul>

                        ))}
                        </ul>
                    </div>
                </li>
                <li><a href="##"> <p>Digital Marketing</p> </a></li>

                <li className='dropdown'>
                    <a href="##"> <p>Writing & Translation  <FiChevronDown /></p> </a>  
                    <div className="dropdownmenu max-content">
                    <ul>
                            <li><a href="##"> Articles & Blog Posts</a> </li>
                            <li><a href="##"> Translation</a> </li>
                            <li><a href="##"> Proofreading & Editing</a> </li>
                            <li><a href="##"> Social Media Copy </a><div className="badge">NEW</div> </li>
                        </ul>
                        <ul>
                           <li><a href="##"> Book & eBook Writing</a></li>
                           <li><a href="##"> Book Editing</a><div className="badge">NEW</div></li>
                           <li><a href="##"> Scriptwriting</a></li>
                           <li><a href="##"> Podcast Writing</a></li>
                           <li><a href="##"> eLearning Content </a><div className="badge">NEW</div></li>
                           <li><a href="##"> Technical Writing</a></li>
                        </ul>
                        <ul>
                            <li><a href="##">Job Descriptions</a><div className="badge">NEW</div></li>
                            <li><a href="##">White Papers</a></li>
                            <li><a href="##">Website Content</a></li>
                            <li><a href="##">Product Descriptions</a></li>
                            <li><a href="##">Press Releases</a></li>
                            <li><a href="##">Business Names</a></li>
                            <li><a href="##">Interview</a></li>
                            <li><a href="##">Legal Writing</a></li>
                            <li><a href="##">Transcripts</a></li>
                            <li><a href="##">Subtitles</a></li>
                            <li><a href="##">Other</a></li>
                        </ul>
                    </div>
                </li>

                <li><a href="##"> <p>Video</p> </a></li>
                <li><a href="##"> <p>Musics</p> </a></li>
                <li className='dropdown'>
                    <a href="##"> <p>Programming & Tech</p> <FiChevronDown /> </a>
                    <div className="dropdownmenu max-content">
                        <ul>
                            <li><a href="##"> WordPress </a></li>
                            <li><a href="##"> Script & CMS </a></li>
                            <li><a href="##"> Game Programming </a></li>
                            <li><a href="##"> Web Programming </a></li>
                            <li><a href="##"> E-Commerce Development </a></li>
                            <li><a href="##"> Mobile Applications </a></li>
                            <li><a href="##"> Desktop Applications </a></li>
                            <li><a href="##"> Tutorials </a></li>
                            <li><a href="##"> Cybersecurity & Protection </a></li>
                        </ul>
                        <ul>
                            <li><a href="##"> Web Site Builders </a></li>
                            <li><a href="##"> Electronics Engineering</a><div className="badge">NEW</div></li>
                            <li><a href="##"> Unit & E2E Testing </a></li>
                            <li><a href="##"> Blockchain & Cryptocurrency </a></li>
                            <li><a href="##"> Nonfungible Token </a></li>
                            <li><a href="##"> Metaverse </a></li>
                            <li><a href="##"> Databases </a></li>
                            <li><a href="##"> Cryptology</a></li>
                            <li><a href="##"> Data Processing </a></li>
                            <li><a href="##"> Big Data </a></li>
                            <li><a href="##"> Data Engineering</a><div className="badge">NEW</div></li>
                            <li><a href="##"> Data Science</a><div className="badge">NEW</div></li>
                            <li><a href="##"> Other </a></li>
                        </ul>
                        
                    </div>
                </li>
                <li><a href="##"> <p>Data</p> <small className='badge'>NEW</small> </a></li>
                <li>
                    <a href="##"> <p>Business</p> <FiChevronDown /> </a>
                    <div className="dropdownmenu max-content">
                        <ul>
                          <li><a href="##"> Market Research </a><div className="badge">NEW</div></li>
                          <li><a href="##"> Sales </a><div className="badge">NEW</div></li>
                          <li><a href="##"> E-Commerce Management </a></li>
                          <li><a href="##"> Customer Care </a><div className="badge">NEW</div></li>
                          <li><a href="##"> Presentations </a></li>
                          <li><a href="##"> Game Concept Design </a></li>
                        </ul>
                        <ul>
                          <li><a href="##"> Business Plans </a></li>
                          <li><a href="##"> Business Consulting </a></li>
                          <li><a href="##"> Legal Consulting </a></li>
                          <li><a href="##"> Financial Consulting </a></li>
                          <li><a href="##"> HR Consulting </a></li>
                          <li><a href="##"> Career Counseling </a></li>
                          <li><a href="##"> Data Analytics </a></li>
                          <li><a href="##"> Data Visualization </a></li>
                          <li><a href="##"> Other </a></li>
                        </ul>
                    </div>
                </li>
                <li><a href="##"> <p>Trending</p> </a></li>
                <li><a href="##"> <p>LifeStyle</p> </a></li>
            </ul>
           <div className='slide-right-button' onClick={scrollRight}>
           <FiChevronRight size={25} />
           </div>
        </div>
    )
}
  
export const TabMenu = () => {

    const forwardRef = React.useRef() 
    const [scrollPosition, setScrollPosition] = useState(0);
    const [fix, setFix] = useState(false);
    const [offsetH, setOffsetH] = useState(0);

    React.useEffect(()=>{
        let h = forwardRef.current.scrollHeight + 115
        setOffsetH(h)
        console.log(h, scrollPosition)
        if(h<scrollPosition)
            setFix(true)
        else
           setFix(false)
        
    },[scrollPosition])

    const handleScroll = () => {
        const position = window.pageYOffset;
        setScrollPosition(position);
    };

    React.useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    


    return (
        <div className={`tabmenu ${fix?'fixed':''}`} ref={forwardRef}>
            <ul className='tabs'>
                <li className='active'>Overview</li>
                <li>Description</li>
                <li>About The Seller</li>
                <li>Compare Packages</li>
                <li>Recommendations</li>
                <li>FAQ</li>
                <li>Reviews</li>
            </ul>
            {offsetH>scrollPosition && (
                 <ul className='actions'>
                    <li><div> <FiDollarSign /> EUR </div></li>
                    <li><div> <FiGlobe /> English </div></li>
                    <li><div className="button"> <FiSearch /> </div></li>
                </ul>
            )}
        </div>
    )
}

export const groupMenu = [
    {title:'Graphic Design', children:[
       {title:'Logo Design'},
       {title:'Book Design'},
       {title:'Album Cover Design'},
       {title:'Social Media Design'},
       {title:'Figma Designs'},
       {title:'AdobeXD Designs'},
       {title:'Sketch Designs'},
       {title:'Photoshop Designs'},
       {title:'Character Modeling'},
    ]},
    {title:'Video & Motions', children:[
        {title:'Twitch Store'},
        {title:'After Effect Presentation'},
        {title:'Premiere Pro Video Editing'},
        {title:'Infographic Design'},
        {title:'Info Design'},
        {title:'Landscape Design'},
    ]},
    {title:'Art & Illustration', children:[
        {title:'Illustration'},
        {title:'Storyboards'},
        ]},
    
    {title:'Web & App Design', children:[
        {title:'Website Design', new:true},
        {title:'UI/UX Design', new:true},
        {title:'Application Design', new:true},
        {title:'Landing Page Design', new:true},
        {title:'Single Page Design', new:true},
        {title:'Mobile App Design', new:true},
        {title:'Email Design', new:true},
    ]},
  
    {title:'Printing', children:[
        {title:'Signage Design'},
        {title:'Brochure Design'},
        {title:'Poster Design'},
        {title:'Catalog Design'},
        {title:'Invitation Design'},
  
    ]},
    {title:'Miscellaneous', children:[
        {title:'Other'},
    ]},
  
  ]
